import Icon from '../icon/index.js';
import { Component } from 'san';

/**
 * 从父组件链中获取首次渲染的时间戳
 * @param parentComponent 父组件
 * @returns 首次渲染的时间戳，如果未找到则返回 0
 */
function getFirstPaint(parentComponent) {
    var _a, _b;
    let atomRenderFlag = { fp: 0 };
    let parent = parentComponent;
    let firstPaint = 0;
    while (parent) {
        if (!(parent === null || parent === void 0 ? void 0 : parent.parentComponent)) {
            atomRenderFlag = ((_a = parent === null || parent === void 0 ? void 0 : parent.data) === null || _a === void 0 ? void 0 : _a.get('renderFlags')) || ((_b = parent === null || parent === void 0 ? void 0 : parent.data) === null || _b === void 0 ? void 0 : _b.get('atomRenderFlags'));
            if (atomRenderFlag && atomRenderFlag.fp) {
                firstPaint = atomRenderFlag.fp;
            }
            else {
                firstPaint = 0;
            }
        }
        parent = parent === null || parent === void 0 ? void 0 : parent.parentComponent;
    }
    return firstPaint;
}

/**
 * @file Image mobile端
 * @author wuhaishan01@baidu.com
 */
/**
 * 双端实现差异
 * - PC: 图片组件若设置了填充模式或填充位置，使用 div 背景图实现；其余情况使用 img 标签实现。
 *       二者展现其一，通过 display: none / block 控制。
 * - Mobile: 无论是否设置填充模式或填充位置，均使用 img 标签实现。
 */
class Image extends Component {
    constructor() {
        super(...arguments);
        /**
         *  图片首次渲染的时间戳
         */
        this.firstPaint = 0;
    }
    initData() {
        return {
            src: '',
            alt: '',
            lazy: false
        };
    }
    inited() {
        let parent = this.parentComponent;
        if (!this.firstPaint) {
            this.firstPaint = getFirstPaint(parent);
        }
    }
    handleLoad(event) {
        this.fire('load', { event });
    }
    handleError(event) {
        this.fire('error', { event });
    }
}
Image.template = `
        <div class="cos-image">
            <!-- 占位区 -->
            <slot s-if="!src" name="placeholder">
                <div class="cos-image-placeholder">
                </div>
            </slot>
            <img
                s-else
                class="cos-image-body"
                s-bind="finalLazy
                    ? {
                        'data-lazy-src': src,
                        'loading': 'lazy'
                    }
                    : {
                        src: src
                    }
                "
                alt="{{alt}}"
                on-load="handleLoad"
                on-error="handleError"
            />
            <!-- 内容区，内容插槽 -->
            <div class="cos-image-content">
                <slot />
            </div>
        </div>
    `;
Image.components = {
    'cos-icon': Icon
};
Image.computed = {
    finalLazy() {
        return this.data.get('lazy') && !this.firstPaint;
    }
};

export { Image as default };
